<template>
  <div class="breadcrumb">
    <tiny-breadcrumb>
      <tiny-breadcrumb-item label="首页" :to="{ path: '/' }">首页</tiny-breadcrumb-item>
      <tiny-breadcrumb-item v-for="item of breadcrumbs" :key="item.id" :label="item.name" @select="breadcrumbItemClick(item)">
        {{ item.name }}
      </tiny-breadcrumb-item>
    </tiny-breadcrumb>
  </div>
</template>

<script>
import { Breadcrumb, BreadcrumbItem } from '@opentiny/vue'
import request from "@/utils/request";

export default {
  name: "MyBreadcrumb",
  components: {
    TinyBreadcrumb: Breadcrumb,
    TinyBreadcrumbItem: BreadcrumbItem
  },
  props: {
    id: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      breadcrumbs: [],
    }
  },
  watch: {
    '$route': {
      immediate: true,
      handler: function(to, from) {
        this.init(to.query.id.toString());
      }
    }
  },
  created() {

  },
  computed: {},
  mounted() {

  },
  methods: {
    init(id){
      this.id = id;
      this.queryBreadcrumbs();
    },

    async queryBreadcrumbs() {
      const {data} = await request.get(`/outSiteMenu/queryBreadcrumbs/` + this.id)
      this.breadcrumbs = data.data;
    },

    breadcrumbItemClick(row) {
      if(row.jump === '4' || row.jump === '5'){
        window.open(row.path, '_blank');
        return;
      }
      this.$router.push({path: '/page' + row.jump , query: {id: row.id}});
    }
  }
};
</script>

<style scoped>

.breadcrumb {
  text-align: left;
  padding-top: 20px;
}

.tiny-breadcrumb {
  --ti-breadcrumb-font-size: 14px;
}

</style>
